const DB_NAME = 'aipnt-ml-db';
const DB_VERSION = 1;
const STORE_NAME = 'projects';

class MLDBManager {
    constructor () {
        this.db = null;
    }

    init () {
        return new Promise((resolve, reject) => {
            if (this.db) return resolve(this.db);

            const request = indexedDB.open(DB_NAME, DB_VERSION);

            request.onerror = event => {
                console.error('IndexedDB open error:', event.target.error);
                reject(event.target.error);
            };

            request.onsuccess = event => {
                this.db = event.target.result;
                resolve(this.db);
            };

            request.onupgradeneeded = event => {
                const db = event.target.result;
                if (!db.objectStoreNames.contains(STORE_NAME)) {
                    db.createObjectStore(STORE_NAME, {keyPath: 'id'});
                }
            };
        });
    }

    getAllProjects () {
        return this.init().then(db => new Promise((resolve, reject) => {
            const transaction = db.transaction([STORE_NAME], 'readonly');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.getAll();

            request.onsuccess = () => {
                // Sort descending by id (timestamp) or lastUpdated
                const list = request.result || [];
                list.sort((a, b) => b.id - a.id);
                resolve(list);
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        }));
    }

    saveProject (project) {
        return this.init().then(db => new Promise((resolve, reject) => {
            const transaction = db.transaction([STORE_NAME], 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.put(project);

            request.onsuccess = () => {
                resolve(project);
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        }));
    }

    deleteProject (id) {
        return this.init().then(db => new Promise((resolve, reject) => {
            const transaction = db.transaction([STORE_NAME], 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.delete(id);

            request.onsuccess = () => {
                resolve(id);
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        }));
    }

    getProject (id) {
        return this.init().then(db => new Promise((resolve, reject) => {
            const transaction = db.transaction([STORE_NAME], 'readonly');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.get(id);

            request.onsuccess = () => {
                resolve(request.result || null);
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        }));
    }
}

const mlDb = new MLDBManager();
export default mlDb;
